<template>
  <div class="index">
    <div class="layout">
      <div class="top">
        <img src="@/assets/images/template/kf.png" @click="openLive800">
        <div class="item" @click="goMessageCenter">
          <span v-if="noticeList && noticeList.length > 0" />
          <img src="@/assets/images/template/live800.png">
        </div>
      </div>
      <div class="banner">
        <swiper :options="Banner">
          <swiper-slide v-for="item in bannerList"><img :src="item.attr.image_url"
              @click="goBannerUrl(item.attr.image_link, item.name)"></swiper-slide>
          <div slot="pagination" class="swiper-pagination" />
        </swiper>
      </div>
      <div v-if="isPrompt">
        <div v-if="infoStatus" class="prompt between1">
          <span><img src="@/assets/images/template/a_top_remind.png">尊敬的投资达人，您的资料未完善，请先完善资料</span>
          <img src="@/assets/images/template/close_1.png" @click="closePrompt">
        </div>
        <div v-if="!infoStatus && unFinishProceedingData && Number(sumFproposalNum) > 0" class="prompt between1">
          <span @click="clickUnFinishPop"><img src="@/assets/images/template/a_top_remind.png">您有{{ sumFproposalNum
          }}项未完成申请<em v-if="depositNum > 0">，存款申请{{ depositNum }}个</em><em v-if="withdrawalNum > 0">，取款申请{{
  withdrawalNum
}}个</em> </span>
          <img src="@/assets/images/template/close_1.png" @click="closePrompt">
        </div>
        <div v-if="!infoStatus && unFinishProceedingData && Number(sumFproposalNum) <= 0" class="indexPrompt">
          <img src="@/assets/images/template/a_top_remind.png">
          <div id="marCon" class="marquee">
            <div class="marWidth">
              <div id="marquee">尊敬的投资达人，如果想体验更多的交易，请<a>下载免费交易平台</a> ></div>
              <div id="marItem" />
            </div>
          </div>
          <img src="@/assets/images/template/close_1.png" @click="closePrompt">
        </div>
      </div>
      <div class="indexNav">
        <ul>
          <li
            v-sa="{ 'ClickDeposit': { 'PType': pageType == 'app' ? 'app端' : pageType == 'trade' ? 'H5交易' : '用户中心', 'AccountType': '真实账户', 'entry': '首页-存款' } }"
            @click="goMoney('recharge')">
            <img class="icon_sxf" src="@/assets/images/index/sxf.png">
            <img src="@/assets/images/index/toolbar_ck.png">
            <span>存款</span>
          </li>
          <li
            v-sa="{ 'ClickWithdrawals': { 'PType': pageType == 'app' ? 'app端' : pageType == 'trade' ? 'H5交易' : '用户中心', 'AccountType': '真实账户', 'entry': '首页-取款' } }"
            @click="goMoney('withdrawal')">
            <img src="@/assets/images/index/toolbar_qk.png">
            <span>取款</span>
          </li>
          <li @click="goReport">
            <img src="@/assets/images/index/toolbar_bb.png">
            <span>报表</span>
          </li>
          <li @click="goPersonalCenter">
            <img src="@/assets/images/index/toolbar_grzx.png">
            <span>个人中心</span>
          </li>
        </ul>
      </div>
      <div class="accInfo">
        <div class="indexTit">
          <div class="item"><span>交易平台</span></div>
          <p @click="goAccInfo">更多</p>
        </div>
        <div v-if="mt5Enabled && currentAccount" class="platform-tab-container">
          <div :class="{'selected': selectedPlatformTab == 'GTS2'}" class="platform-tab" @click="selectPlatformTab('GTS2')">创富 CFD</div>
          <div :class="{'selected': selectedPlatformTab == 'MT5'}" class="platform-tab" @click="selectPlatformTab('MT5')">MT5</div>
        </div>
        <div v-if="currentAccount && !(selectedPlatformTab == 'MT5' && currentAccount && !accTradeInfoList.find(account => account.platform == 'MT5'))" class="accCon">
          <div class="infoTit" @click="goAccOverview">
            <span><img src="@/assets/images/index/zh.png">{{ currentAccount.accountNo }}</span>
            <img src="@/assets/images/template/a_top_return.png">
          </div>
          <div class="accStatus">
            <ul>
              <li @click="goAccLevel(currentAccount.accountLevel)">
                <span>
                  <img src="@/assets/images/index/wh.png">{{currentAccount.accountLevelName }}
                </span>
                <p>级别</p>
              </li>
              <li><span>{{ currentAccount.accountStatusName }}</span>
                <p>状态</p>
              </li>
              <li><span>${{ currentAccount.balance || '0.00' }}</span>
                <p>余额</p>
              </li>
            </ul>
            <div class="btn-group">
              <a @click="goMoney('recharge')">存款</a>
              <a v-if="mt5Enabled" class="transfer-btn" @click="goToPlatformTransfer">转账</a>
            </div>
          </div>
        </div>
        <div v-if="mt5Enabled && selectedPlatformTab == 'MT5' && currentAccount && !accTradeInfoList.find(account => account.platform == 'MT5')" class="accCon openAccContainer">
          <div>
            尚未开通账号，<a @click="goToAddMT5CheckPassword">点击开通</a>
          </div>
        </div>
      </div>
      <div class="indexBank">
        <swiper v-if="withdrawBank && withdrawBank.length > 0"
          v-sa="{ 'binding_cards': { 'PType': pageType == 'app' ? 'app端' : pageType == 'trade' ? 'H5交易' : '用户中心', 'AccountType': '真实账户', 'entry': '首页-银行卡列表' } }"
          :options="Bank" @click="BankCardList">
          <swiper-slide v-for="item in withdrawBank">
            <div class="item">
              <p>我的银行卡</p>
              <span>{{ item.bankName }}（{{ (item.bankAccountNumber).replace(/^(\d{0})\d+(\d{4})$/, "$2") }}）</span>
            </div>
          </swiper-slide>
          <div slot="pagination" class="swiper-pagination" />
        </swiper>
        <div v-else class="item" @click="addBankCard">
          <p>我的银行卡</p>
          <span>去添加银行卡+</span>
        </div>
      </div>
      <div class="indexBank profit">
        <div class="item" @click="goProfitAndLossRecord">
          <p>近7日盈利（美元）</p>
          <span :class="profitAndLoss > 0 ? 'rise' : profitAndLoss == 0 ? '' : 'fall'">盈利<em>{{
            parseFloat(profitAndLoss).toFixed(2)
          }}</em></span>
        </div>
      </div>
      <div class="messCenter">
        <div class="indexTit">
          <div class="item"><span>消息中心</span></div>
          <p @click="goMessageCenter">更多</p>
        </div>
        <div class="centerList">
          <ul>
            <li v-if="noticeList[0]" @click="goMessageDetail(noticeList[0].id)">
              <span>最新公告<em>{{ new Date((noticeList[0].validFrom.split(' ')[0]).replace(/-/g, "/")).format("MM/dd")
              }}</em></span>
              <p>{{ noticeList[0].title }}</p>
            </li>
            <li v-if="noticeTradeList[0]" @click="goMessageDetail(noticeTradeList[0].id)">
              <span>交易时间安排<em>{{ new Date((noticeTradeList[0].validFrom.split(' ')[0]).replace(/-/g, "/")).format("MM/dd")
              }}</em></span>
              <p>{{ noticeTradeList[0].title }}</p>
            </li>
          </ul>
        </div>
        <div class="centerCon">
          <ul>
            <li v-for="item in noticeList" @click="goMessageDetail(item.id)">
              <div class="item"><span>{{ item.title }}</span><em v-if="item.isNewNotice">NEW</em></div>
              <p>{{ item.type }} {{ item.validFrom.split(' ')[0] }}</p>
            </li>
            <li v-if="!noticeList || noticeList.length <= 0">
              <span style="text-align: center; margin-left: auto; margin-right: auto; font-size: 0.3rem">未有最新消息</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="indexAd" @click="goTrade"><img src="@/assets/images/index/dbhb.png"></div>
    </div>
    <!--存取款流程-->
    <DepositAndWithdrawal v-if="isDepositAndWithdrawal" :is-deposit-and-withdrawal="isDepositAndWithdrawal"
      :source="source" :this-page-type="pageType" :money-status="moneyStatus" @moneyStatue="moneyStatue" />
    <div id="bottomRight">
      <img v-if="isUnFinishIcon" id="unFinish" src="@/assets/images/template/rw.png" @click="clickUnFinishPop">
      <img id="topBtn" src="@/assets/images/template/toolbar_top.png">
    </div>
    <!--存取款未完成事项-->
    <div v-if="isUnFinishPop" class="popFixed">
      <div class="masking" @click="closeUnFinishPop" />
      <div class="tcCon">
        <div class="unFinish">
          <div class="title"><span>未完成事项</span></div>
          <div class="unFinishNav">
            <ul v-if="depositNum > 0 && withdrawalNum <= 0">
              <li class="checked"><span>存款申请</span></li>
            </ul>
            <ul v-if="depositNum <= 0 && withdrawalNum > 0">
              <li class="checked"><span>取款申请</span></li>
            </ul>
            <ul v-if="depositNum > 0 && withdrawalNum > 0">
              <li v-for="(item, index) in unFinishNav" :class="{ checked: isUnFinish == index }" @click="tabClick(index)">
                <span>{{ item.name }}</span>
                <p />
              </li>
            </ul>
          </div>
          <div id="unFinishCon" class="unFinishCon">
            <ul v-if="isUnFinish == 0">
              <li v-for="item in depositList">
                <div class="unFinishItem">
                  <p class="color">{{ item.pno }} <button :disabled="item.attachments.length > 0"
                      @click.stop="goUploadDocuments(item, tabIndex)" class="uploadBtn">{{ item.attachments.length > 0
                        ?
                        '已上传' : '上传凭证' }}</button></p><span><em>$</em>{{ item.transAmount }}</span>
                </div>
                <div class="unFinishItem">
                  <p>{{ item.gatewayCode }}<br>{{ new Date((item.createDate).replace(/-/g, "/")).format("hh:ss:qq") }}</p>
                  <p>{{
                    item.proposalStatus == 0 ? '待确认' : item.proposalStatus == 1 ? '待审批' : item.proposalStatus == 2 ? '已审批'
                      : item.proposalStatus == -1 ? '已取消;' : '逾期'
                  }}</p>
                </div>
              </li>
            </ul>
            <ul v-if="isUnFinish == 1">
              <li v-for="item in withdrawalList">
                <div class="unFinishItem">
                  <p class="color">{{ item.pno }}</p><span><em>$</em>{{ item.depostMount }}</span>
                </div>
                <div class="unFinishItem">
                  <p>{{ item.withdrewBankName }}<br>{{ new Date((item.createDate).replace(/-/g, "/")).format("hh:ss:qq")
                  }}</p>
                  <p>{{ item.stateName }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="btnCon only">
          <span @click="closeUnFinishPop">知道了</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require('swiper/css/swiper.css')
require('@/assets/css/index.css')
import DepositAndWithdrawal from '@/view/module/DepositAndWithdrawal.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import utils from '@/utils/tradeDataUtil'
import api from '@/plugins/api'
import { mapState } from 'vuex'
import { isMT5Enabled } from '@/utils/helper'
export default {
  name: 'Index',
  components: { swiper, swiperSlide, DepositAndWithdrawal },
  computed: {
    ...mapState(['user', 'platform', 'gts2CustomerId', 'pageType'])
  },
  data() {
    return {
      bannerList: [],
      swiperAdList: [],
      Banner: {
        notNextTick: true,
        loop: false,
        initialSlide: 0,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true
        },
        speed: 800,
        pagination: {
          el: '.swiper-pagination',
          clickable: true // 允许点击小圆点跳转
        }
      },
      Bank: {
        notNextTick: true,
        loop: false,
        initialSlide: 0,
        autoplay: false,
        speed: 800,
        pagination: {
          el: '.swiper-pagination',
          clickable: true // 允许点击小圆点跳转
        }
      },
      isPrompt: true,
      isDepositAndWithdrawal: false,
      source: 'home',
      moneyStatus: '',
      withdrawBank: '',
      accTradeInfoList: [],
      balance: '', // 余额
      noticeList: '',
      noticeTradeList: '',
      beginTime: new Date(utils.getDay(-6)).format('Y-MM-dd'),
      endTime: new Date().format('Y-MM-dd'),
      profitAndLoss: '',
      infoStatus: false, // 资料是否完善
      unFinishProceedingData: '',
      sumFproposalNum: '', // 未完成事项总数
      depositList: '', // 未完成存款申请
      depositNum: '', // 存款款未完成事项
      withdrawalList: '', // 未完成取款申请
      withdrawalNum: '', // 取款未完成事项
      myMar: 0,
      isUnFinishPop: false,
      isUnFinishIcon: false,
      unFinishNav: [{ name: '存款申请', id: '0' }, { name: '取款申请', id: '1' }],
      isUnFinish: 0,
      tradeUrl: process.env.VUE_APP_TRADE,
      scrollHeight: '',
      flavor: this.$route.query.flavor,
      currentAccount: null,
      selectedPlatformTab: '',
      mt5Enabled: isMT5Enabled()
    }
  },
  created() {
    const readyData = this.$qs.stringify({
      account: this.user.loginname,
      adPosition: '1|2',
      channel: process.env.VUE_APP_TITLE_CHANNEL
    })
    api.queryForApp().then(res => {
      if (res.status == 200 && res.data.code == 200) {
        if (res.data.ch_msg) {
          if (res.data.ch_msg) this.bannerList = res.data.ch_msg
        }
      }
    })
  },
  mounted() {
    this.selectedPlatformTab = this.platform
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.certifyInfo()
    this.withdrawBankList()
    this.getProfitAndLossRecord()
    this.AccTradeInfo()
    this.noticeData()
    this.noticeTradeData()
    this.goTop()
    this.$nextTick(() => {
      var speed = 40// 数值越大，速度越慢
      this.myMar = setInterval(this.Marquee, speed)
      var marCon = document.getElementById('marCon')
      if (marCon != null && marCon != '') {
        marCon.onmouseover = () => {
          clearInterval(this.myMar)
        }
        marCon.onmouseout = () => {
          this.myMar = setInterval(this.Marquee, speed)
        }
      }
    })
  },
  destroyed() {
    clearInterval(this.myMar)
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.goTop()
  },
  methods: {
    goUploadDocuments(data) {
      this.$router.push({ path: '/home/uploadDocuments', query: { pno: data.pno } })
    },
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    removeStyle() {
      const main = document.getElementById('main')
      main.removeAttribute('style')
      window.scrollTo(0, this.scrollHeight)
    },
    addStyle() {
      const main = document.getElementById('main')
      let top, body, css
      if (document.documentElement) {
        body = document.documentElement
      } else if (document.body) {
        body = document.body
      }
      if (body.scrollTop) {
        top = body.scrollTop
      } else if (window.pageYOffset) {
        top = window.pageYOffset
      }
      css = 'width: 100%; height: 100%; position: fixed; top: -' + top + 'px;left: 0;'
      main.style.cssText = css
      this.scrollHeight = top
    },
    openLive800() {
      var url = `https://onlinecs.cffx139.net/Web/im.aspx?_=t&accountid=137707&visitorid=${new Date().getTime()}`
      var left = (screen.width / 2) - (600 / 2)
      var top = (screen.height / 2) - (400 / 2)
      window.open(url,
        'DescriptiveWindowName',
        'resizable,scrollbars=yes,status=1,width=800, height=550, top=' + top + ', left=' + left)
    },
    goBannerUrl(url, title) {
      this.$bus.$emit('loading', false)
      this.$router.push({
        path: '/home/external', query: {
          url: url,
          title: title
        }
      })
    },
    closePrompt() {
      this.isPrompt = false
    },
    certifyInfo() {
      api.getCertifyInfo().then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            if (res.data.data) {
              this.infoStatus = false
              this.unFinishProceeding()
            } else this.infoStatus = true
          }
        }
      })
    },
    unFinishProceeding() {
      api.getUnfinishProceeding(this.gts2CustomerId).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            if (res.data.data) {
              this.unFinishProceedingData = res.data.data
              this.sumFproposalNum = res.data.data.sumFproposalNum
              this.depositNum = res.data.data.depositNum
              this.depositList = res.data.data.depositList
              this.withdrawalNum = res.data.data.withdrawalNum
              this.withdrawalList = res.data.data.withdrawalList
              if (this.depositNum > 0 && this.withdrawalNum <= 0) this.isUnFinish = 0
              if (this.depositNum <= 0 && this.withdrawalNum > 0) this.isUnFinish = 1
            }
          }
        }
      })
    },
    clickUnFinishPop() {
      this.addStyle()
      this.isUnFinishPop = !this.isUnFinishPop
    },
    closeUnFinishPop() {
      this.removeStyle()
      this.isPrompt = false
      this.isUnFinishIcon = true
      this.isUnFinishPop = !this.isUnFinishPop
    },
    tabClick(index) {
      this.isUnFinish = index
    },
    Marquee() {
      var marCon = document.getElementById('marCon')
      var marquee = document.getElementById('marquee')
      var marItem = document.getElementById('marItem')
      if (marquee != null && marquee != '') {
        marItem.innerHTML = marquee.innerHTML
        if (marCon.scrollLeft - marItem.offsetWidth >= 0) {
          marCon.scrollLeft -= marquee.offsetWidth
        } else {
          marCon.scrollLeft++
        }
      }
    },
    goMoney(data) {
      this.isDepositAndWithdrawal = true
      this.moneyStatus = data
    },
    moneyStatue(data) {
      this.isDepositAndWithdrawal = data
    },
    goReport() {
      this.$bus.$emit('loading', false)
      this.$store.dispatch('setTabIndex', 0)
      this.$router.push({ path: '/home/report' })
    },
    goPersonalCenter() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/personalCenter' })
    },
    BankCardList() {
      this.$bus.$emit('loading', false)
      this.$store.dispatch('setTabIndex', 0)
      this.$router.push({ path: '/home/bankList' })
    },
    addBankCard() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/addBankCard', query: { bankType: 0 } })
    },
    goProfitAndLossRecord() {
      this.$bus.$emit('loading', false)
      this.$store.dispatch('setTabIndex', 2)
      this.$router.push({ path: '/home/report' })
    },
    withdrawBankList() {
      const arrList = []
      api.getWithdrawBankList().then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            if (res.data.data.withdrawBankList) {
              const list = res.data.data.withdrawBankList
              for (const j in list) {
                if (list[j].approveStatus == 'APPROVAL') {
                  arrList.push(list[j])
                }
              }
              this.withdrawBank = arrList
            }
          }
        }
      })
    },
    getProfitAndLossRecord() {
      const data = {
        index: 1,
        pageSize: 1,
        beginTime: this.beginTime,
        endTime: this.endTime,
        platform: this.platform
      }
      api.profitAndLossRecord(data).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            this.profitAndLoss = res.data.data.total.profit
          }
        }
      })
    },
    goAccInfo() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/accInfo' })
    },
    goAccOverview() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/accOverview' })
    },
    goAccLevel(accountLevel) {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/accLevel', query: { accountLevel: accountLevel, flavor: this.flavor } })
    },
    AccTradeInfo() {
      api.getAccTradeInfo(this.gts2CustomerId).then(res => {
        if (res.data.code == 200) {
          this.balance = res.data.data.accountSummary.totalMoney
          this.accTradeInfoList = res.data.data.accTradeInfoList
          this.currentAccount = this.accTradeInfoList.find(account => account.platform == this.platform)
        }
      })
    },
    goMessageCenter() {
      this.$bus.$emit('loading', false)
      this.$store.dispatch('setTabIndex', 1)
      this.$router.push({ path: '/home/messageCenter' })
    },
    noticeData() {
      const data = {
        index: 1,
        pageSize: 3,
        noticeType: 1
      }
      api.getNoticeList(this.$qs.stringify(data)).then(res => {
        if (res.data.code == 200) {
          const dataWithinSevenDays = res.data.data.noticeRecordList.filter(ele => {
            const creatDate = new Date(utils.isIOS() ? ele.createDate.replace(/-/gi, '/') : ele.createDate).setHours(0, 0, 0, 0)
            const targetDate = new Date()
            targetDate.setDate(targetDate.getDate() - 7)
            return creatDate > targetDate
          })
          // this.noticeList = res.data.data.noticeRecordList;
          this.noticeList = dataWithinSevenDays
          // this.noticeList = []
        }
      })
    },
    noticeTradeData() {
      const data = {
        index: 1,
        pageSize: 1,
        noticeType: 2
      }
      api.getNoticeList(this.$qs.stringify(data)).then(res => {
        if (res.data.code == 200) {
          const dataWithinSevenDays = res.data.data.noticeRecordList.filter(ele => {
            const creatDate = new Date(utils.isIOS() ? ele.createDate.replace(/-/gi, '/') : ele.createDate).setHours(0, 0, 0, 0)
            const targetDate = new Date()
            targetDate.setDate(targetDate.getDate() - 7)
            return creatDate > targetDate
          })
          this.noticeTradeList = dataWithinSevenDays
          // this.noticeTradeList = res.data.data.noticeRecordList;
        }
      })
    },
    goMessageDetail(id) {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/messageDetail', query: { id: id } })
    },
    goTop() {
      const backTop = document.getElementById('topBtn'); let flag = true; let time = null
      window.onscroll = function () {
        const scroll = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
        if (scroll >= 300) {
          backTop.classList.add('show')
        } else {
          backTop.classList.remove('show')
        }
        if (!flag) clearInterval(time)
        flag = false
      }
      backTop.addEventListener('click', function () {
        const scroll = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
        time = setInterval(function () {
          document.body.scrollTop = document.documentElement.scrollTop -= scroll
          flag = true
          if (document.body.scrollTop == 0) {
            clearInterval(time)
            time = null
          }
        }, 200)
      })
    },
    goTrade() {
      this.$bus.$emit('loading', false)
      const data = {
        customerNumber: this.user.loginname,
        password: this.user.pwd
      }
      api.tradeLogin(this.$qs.stringify(data)).then(res => {
        if (res.data.code == 200) {
          var uuid = res.data.data.uuid
          const url = this.tradeUrl + 'token?token=' + uuid
          this.$bus.$emit('loading', true)
          window.location.href = url
        }
      })
    },
    selectPlatformTab(platform) {
      this.selectedPlatformTab = platform
      
      this.currentAccount = this.accTradeInfoList.find(account => account.platform == this.selectedPlatformTab)
      if (!this.currentAccount) { // If MT5 account is not open, default to GTS2 account
        this.currentAccount = this.accTradeInfoList[0]
      }

      this.$store.dispatch('setPlatform', this.currentAccount.platform)
      this.$store.dispatch('setPlatformName', this.currentAccount.platformName)
      this.$store.dispatch('setGts2AccountId', this.currentAccount.gts2AccountId)

      this.getProfitAndLossRecord()
    },
    goToPlatformTransfer() {
      if (!this.accTradeInfoList.find(account => account.platform == 'MT5')) {
        this.goToAddMT5CheckPassword()
        return
      }
      this.$router.push({ path: '/home/platformTransfer', query: { fromPlatform: this.currentAccount.platform }})
    },
    goToAddMT5CheckPassword() {
      this.$router.push({ path: '/home/addMT5CheckPassword' })
    }
  }
}
</script>